module.exports = __webpack_public_path__ + "img/HSL_logo.0dc5ac87.svg";